<p-listbox [options]="options" [(ngModel)]="selectedContent.selectedValues" [multiple]="true" [checkbox]="true" optionLabel="text"
           styleClass="p-listbox-no-highlight p-listbox-no-header" (onChange)="onChange($event)" inputId="booleanList">
  <ng-template let-filterItem let-i="index" pTemplate="item">
    <span id="option_{{filterItem.code}}">{{filterItem.text}}</span>
  </ng-template>
</p-listbox>
